/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Stack } from '@mui/material';
import { useRecoilState } from 'recoil';
import { CssTextField } from 'components/select';
import { isAppNameValid, landingZoneData } from 'pages/app-profiles/store';

const AppName = () => {
    const [landingZoneForm, setLandingZoneForm] = useRecoilState(landingZoneData);
    const [isValid, setAppNameVaild] = useRecoilState(isAppNameValid);
    const [ShrinkField, setShrinkField] = React.useState(false);

    const setAppName = (appName) => {
        setLandingZoneForm({
            ...landingZoneForm,
            appName,
        });
    };

    const handleChange = (value) => {
        if (value !== '' && value !== null && value !== undefined) {
            if (value?.length > 6 || value?.length < 3) {
                setAppNameVaild(false);
                setAppName(value);
            } else if (!/^[a-zA-Z]+$/.test(value)) {
                setAppNameVaild(false);
                setAppName(value);
            } else {
                setAppNameVaild(true);
                setAppName(value);
            }
        } else {
            setAppNameVaild(false);
            setAppName(null);
        }
    };

    React.useEffect(() => {
        if (landingZoneForm?.appName) setAppName(landingZoneForm?.appName);
    }, [landingZoneForm?.appName]);

    React.useEffect(() => {
        if (!ShrinkField) setShrinkField(landingZoneForm?.appName?.length > 0);
    }, [landingZoneForm?.appName]);

    return (
        <>
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                <CssTextField
                    size="small"
                    label="App Name "
                    fullWidth
                    onChange={(event) => handleChange(event.target.value)}
                    value={landingZoneForm?.appName || ''}
                    InputLabelProps={{ shrink: ShrinkField }}
                    onClick={() => setShrinkField(true)}
                    autoComplete="off"
                    error={!isValid}
                    helperText={`
                    ${!isValid ? 'App name should be min. 3 to max. 6 chars and alphabets only' : ''}
                `}
                />
            </Stack>
        </>
    );
};

export default React.memo(AppName);
